import LightDarkImg from "discourse/components/light-dark-img";
import PluginOutlet from "discourse/components/plugin-outlet";
import lazyHash from "discourse/helpers/lazy-hash";

<template>
  <div
    class="circles__background
      {{if @model.hasBackground '--has-image'}}
      {{unless @model.hasBackground '--blank'}}"
    ...attributes
  >
    <PluginOutlet
      @name="circles-background"
      @outletArgs={{lazyHash model=@model}}
    >
      {{#if @model.hasBackground}}
        <LightDarkImg
          @lightImg={{@model.category.uploaded_background}}
          @darkImg={{@model.category.uploaded_background_dark}}
        />
      {{/if}}
    </PluginOutlet>
  </div>
</template>
